<template>
  <div class="device-auth-rule">
    <el-form
      :model="formData"
      :rules="rules"
      ref="dataForm"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-form-item label="配置名称:" prop="name" required>
        <el-input v-model="formData.name" placeholder="请输入配置名称"></el-input>
      </el-form-item>
      
      <el-form-item label="设备认证规则:" required>
        <div class="checkbox-grid">
          <div class="grid-header">
            <div class="header-cell"></div>
            <div class="header-cell">esim1</div>
            <div class="header-cell">esim2</div>
            <div class="header-cell">usim</div>
            <div class="header-cell">esim3</div>
          </div>
          
          <div class="grid-row" v-for="(row, rowIndex) in checkboxData" :key="rowIndex">
            <div class="row-label">{{ getOperatorName(rowIndex) }}</div>
            <div 
              class="checkbox-cell" 
              v-for="(checked, colIndex) in row" 
              :key="colIndex"
            >
              <el-checkbox 
                v-model="checkboxData[rowIndex][colIndex]"
                @change="onCheckboxChange"
              ></el-checkbox>
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "DeviceAuthRule",
  props: {
    initData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        name: "",
        jsonStr: "{}"
      },
      // 4x4 勾选框数据，初始化为全0
      checkboxData: [
        [false, false, false, false], // 广电
        [false, false, false, false], // 移动
        [false, false, false, false], // 联通
        [false, false, false, false]  // 电信
      ],
      rules: {
        name: [
          { required: true, message: "请输入配置名称", trigger: "blur" }
        ]
      }
    };
  },
  watch: {
    initData: {
      handler(newVal) {
        if (newVal && newVal.name) {
          this.formData = JSON.parse(JSON.stringify(newVal));
          this.parseJsonStrToCheckbox();
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 获取运营商名称
    getOperatorName(index) {
      const operators = ["广电", "移动", "联通", "电信"];
      return operators[index] || "";
    },
    
    // 勾选框变化时更新JSON数据
    onCheckboxChange() {
      this.updateJsonStr();
    },
    
    // 将勾选框数据转换为JSON字符串
    updateJsonStr() {
      const matrix = this.checkboxData.map(row => 
        row.map(checked => checked ? 1 : 0)
      );
      this.formData.jsonStr = JSON.stringify(matrix);
    },
    
    // 将JSON字符串解析为勾选框数据
    parseJsonStrToCheckbox() {
      try {
        if (this.formData.jsonStr && this.formData.jsonStr !== "{}") {
          const matrix = JSON.parse(this.formData.jsonStr);
          if (Array.isArray(matrix) && matrix.length === 4) {
            this.checkboxData = matrix.map(row => 
              row.map(value => value === 1)
            );
          }
        }
      } catch (error) {
        console.error("解析JSON字符串失败:", error);
        // 如果解析失败，保持默认的全false状态
      }
    },
    
    // 重置表单
    resetForm() {
      this.checkboxData = [
        [false, false, false, false],
        [false, false, false, false],
        [false, false, false, false],
        [false, false, false, false]
      ];
      this.updateJsonStr();
    }
  },
  
  mounted() {
    // 初始化时更新JSON字符串
    this.updateJsonStr();
  }
};
</script>

<style scoped>
.device-auth-rule {
  padding: 20px;
}

.checkbox-grid {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}

.grid-header {
  display: flex;
  background-color: #f5f7fa;
  border-bottom: 1px solid #dcdfe6;
}

.header-cell {
  flex: 1;
  padding: 12px 8px;
  text-align: center;
  font-weight: bold;
  color: #606266;
  border-right: 1px solid #dcdfe6;
}

.header-cell:last-child {
  border-right: none;
}

.grid-row {
  display: flex;
  border-bottom: 1px solid #dcdfe6;
}

.grid-row:last-child {
  border-bottom: none;
}

.row-label {
  flex: 1;
  padding: 12px 8px;
  text-align: center;
  font-weight: bold;
  color: #606266;
  background-color: #f5f7fa;
  border-right: 1px solid #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkbox-cell {
  flex: 1;
  padding: 12px 8px;
  text-align: center;
  border-right: 1px solid #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkbox-cell:last-child {
  border-right: none;
}

/* 确保勾选框居中显示 */
.checkbox-cell .el-checkbox {
  margin: 0;
}
</style>
